export default {
  MY_SCHEDULE_CARD: {
    TITLE: `My Schedule`,
    SUMMARY: ``
  },
  PROJECT_INFO_MODAL: {
    TITLE: `Project information`,
    SUMMARY: ``,
    PROJECT_NAME: `Name:`,
    PROJECT_OWNERS: `Project owners:`
  },
  NO_SHIFTS: `No shifts`,
  NO_SHIFTS_TODAY: `You don't have a shift today, take it easy 🏖`,
  PREVIOUS_WEEK: `Previous week`,
  THIS_WEEK: `This week`,
  NEXT_WEEK: `Next week`,
  CREATE_ATTENDANCE_REQUEST: `Create an attendance request`,
  LOADING_SHIFTS: `Loading shifts`,
  SHIFT_OPTIONS: `Shift options`,
  SEE_MY_CO_WORKERS: `See my co-workers`,
  ON_CALL: `On call`,
  VIEW_COMMENT: `View additional information`,
  ADDITIONAL_INFORMATION: `Additional information`,
  PUNCH_INFORMATION: `Punch information`,
  TIME_OFF: `Time off`,
  CO_WORKERS_MODAL: {
    TITLE: `People working at the same time as me.`,
    SUMMARY: ``
  },
  EXPORT_SCHEDULE: {
    TITLE: `Export the schedule in PDF`,
    SUMMARY: `Choose a range of dates to export your schedule`,
    LABEL: `Dates`,
    PLACEHOLDER: `Choose dates`,
    DESCRIPTION: ``
  },
  PDF_TITLE: `pdf_Schedule_{{employee}}_{{ start }}-{{ end }}`,
  RANGE: {
    LABEL: `Dates`,
    PLACEHOLDER: `Choose a range of dates`,
    DESCRIPTION: ``
  },
  SCHEDULE_HEADER: `{{employee}}'s schedule from {{ start }} to {{ end }}`
}
